const internalEn = {
  en: {
    selection: {
      commission_type: [
        ['M', 'Monthly'],
        ['Q', 'Quarterly'],
        ['H', 'Semi-Annually'],
        ['A', 'Annually'],
      ],
    },
  },
};

export default internalEn;
